import React, { useState } from "react";
import { Grid as MuiGrid } from "@mui/material";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Input, NumericTextBox } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";

import { retailSalesConstants } from "../../../../../_redux/_constants/retailSales.constants";
import { normaliseWeek, WEEK_PROBLEM_MESSAGE } from "../../retailSalesWeek";

const EMPTY_WINNER = {
     dealer: null,
     jobRole: null,
     jobTitle: null,
     firstName: "",
     lastName: "",
     email: "",
     week: "",
     points: retailSalesConstants.RETAIL_SALES_DEFAULT_REWARD_POINTS,
};

/**
 * Adds a single winner by hand. It submits through the same add-winners call the Excel import
 * uses, as a batch of one, so the outcome is reported the same way.
 */
export default function AddWinnerManualForm(props) {
     const { dealerOptions, jobRoleOptions, jobTitleOptions, isSubmitting, onSubmit, onDealerSearch } = props;

     const [winner, setWinner] = useState(EMPTY_WINNER);

     const setField = (field, value) =>
          setWinner((previous) => ({ ...previous, [field]: value }));

     const canSubmit =
          winner.dealer &&
          winner.jobRole &&
          winner.firstName.trim() &&
          winner.lastName.trim() &&
          winner.email.trim() &&
          normaliseWeek(winner.week);

     const submit = () => {
          onSubmit([
               {
                    dealershipId: winner.dealer.id,
                    jobRoleId: winner.jobRole.id,
                    email: winner.email.trim(),
                    firstName: winner.firstName.trim(),
                    lastName: winner.lastName.trim(),
                    rewardValueGbp:
                         Number(winner.points) /
                         retailSalesConstants.RETAIL_SALES_POINTS_PER_GBP,
                    jobTitle: winner.jobTitle ? winner.jobTitle.name : undefined,
                    week: normaliseWeek(winner.week),
               },
          ]);
     };

     return (
          <MuiGrid container spacing={2} sx={{ maxWidth: "900px" }}>
               <MuiGrid item xs={12} lg={6}>
                    <DropDownList
                         style={{ width: "100%" }}
                         label="Dealer"
                         data={dealerOptions}
                         textField="label"
                         dataItemKey="id"
                         value={winner.dealer}
                         filterable={true}
                         onFilterChange={(event) =>
                              onDealerSearch(event.filter ? event.filter.value : "")
                         }
                         onChange={(event) => setField("dealer", event.value)}
                    />
               </MuiGrid>
               <MuiGrid item xs={12} lg={6}>
                    <DropDownList
                         style={{ width: "100%" }}
                         label="Role"
                         data={jobRoleOptions}
                         textField="name"
                         dataItemKey="id"
                         value={winner.jobRole}
                         onChange={(event) => setField("jobRole", event.value)}
                    />
               </MuiGrid>
               <MuiGrid item xs={12} lg={6}>
                    <DropDownList
                         style={{ width: "100%" }}
                         label="Job title"
                         data={jobTitleOptions}
                         textField="name"
                         dataItemKey="id"
                         value={winner.jobTitle}
                         filterable={true}
                         onChange={(event) => setField("jobTitle", event.value)}
                    />
               </MuiGrid>
               <MuiGrid item xs={12} lg={6}>
                    <Input
                         style={{ width: "100%" }}
                         label="First name"
                         value={winner.firstName}
                         onChange={(event) =>
                              setField("firstName", event.value)
                         }
                    />
               </MuiGrid>
               <MuiGrid item xs={12} lg={6}>
                    <Input
                         style={{ width: "100%" }}
                         label="Last name"
                         value={winner.lastName}
                         onChange={(event) => setField("lastName", event.value)}
                    />
               </MuiGrid>
               <MuiGrid item xs={12} lg={6}>
                    <Input
                         style={{ width: "100%" }}
                         label="Email"
                         value={winner.email}
                         onChange={(event) => setField("email", event.value)}
                    />
               </MuiGrid>
               <MuiGrid item xs={12} lg={3}>
                    <Input
                         style={{ width: "100%" }}
                         label="Week"
                         value={winner.week}
                         onChange={(event) => setField("week", event.value)}
                    />
                    {winner.week.trim() && !normaliseWeek(winner.week) && (
                         <p
                              style={{
                                   color: "#c62828",
                                   margin: "4px 0 0",
                                   fontSize: "12px",
                              }}
                         >
                              {WEEK_PROBLEM_MESSAGE}
                         </p>
                    )}
               </MuiGrid>
               <MuiGrid item xs={12} lg={3}>
                    <NumericTextBox
                         style={{ width: "100%" }}
                         label="Points"
                         min={0}
                         step={100}
                         value={winner.points}
                         onChange={(event) => setField("points", event.value)}
                    />
               </MuiGrid>
               <MuiGrid item xs={12}>
                    <Button
                         type="button"
                         themeColor="primary"
                         disabled={!canSubmit || isSubmitting}
                         onClick={submit}
                    >
                         Add winner
                    </Button>
               </MuiGrid>
          </MuiGrid>
     );
}
